import {
  IMAGE_UPLOAD,
  IMAGE_UPLOAD_FAILURE,
  IMAGE_UPLOAD_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const imageUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMAGE_UPLOAD:
      return { ...state, loading: true };
    case IMAGE_UPLOAD_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case IMAGE_UPLOAD_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default imageUploadReducer;
